
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    if (!acceptTerms) {
      alert('يرجى الموافقة على سياسة الاستخدام');
      return;
    }
    navigate('/home');
  };

  const handleTeacherLogin = () => {
    navigate('/teacher-dashboard');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-[#E8F5F3] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-[#0F2A3A] rounded-2xl">
            <i className="ri-file-list-3-line text-3xl text-[#1ABC9C]"></i>
          </div>
          <h1 className="text-3xl font-bold text-[#0F2A3A]">تسجيل الدخول الآمن</h1>
          <p className="text-slate-600 mt-2">ادخل إلى منصة التقييم التعليمي</p>
        </div>

        {/* Login Form */}
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-2">
                رقم الجوال أو البريد الإلكتروني
              </label>
              <div className="relative">
                <input
                  type="text"
                  value={identifier}
                  onChange={(e) => setIdentifier(e.target.value)}
                  className="w-full px-4 py-3 pr-12 border-2 border-slate-200 rounded-xl focus:border-[#1ABC9C] focus:outline-none transition-colors text-base"
                  placeholder="05xxxxxxxx أو example@email.com"
                  required
                />
                <i className="ri-user-line absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 text-xl"></i>
              </div>
            </div>

            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-2">
                كلمة المرور
              </label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-4 py-3 pr-12 border-2 border-slate-200 rounded-xl focus:border-[#1ABC9C] focus:outline-none transition-colors text-base"
                  placeholder="••••••••"
                  required
                />
                <i className="ri-lock-line absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 text-xl"></i>
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 cursor-pointer"
                >
                  <i className={`text-xl ${showPassword ? 'ri-eye-off-line' : 'ri-eye-line'}`}></i>
                </button>
              </div>
            </div>

            <div>
              <label className="flex items-start gap-3 cursor-pointer">
                <input 
                  type="checkbox" 
                  checked={acceptTerms}
                  onChange={(e) => setAcceptTerms(e.target.checked)}
                  className="w-5 h-5 mt-0.5 text-[#1ABC9C] rounded cursor-pointer" 
                />
                <span className="text-sm text-slate-600 leading-relaxed">
                  أوافق على سياسة الاستخدام وشروط الخدمة الخاصة بمنصة التقييم التعليمي
                </span>
              </label>
            </div>

            <button
              type="submit"
              className="w-full py-3 bg-[#0F2A3A] text-white font-semibold rounded-xl hover:bg-[#1a3d52] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              تسجيل الدخول
            </button>
          </form>

          <div className="mt-6 space-y-3">
            <button
              onClick={() => navigate('/home')}
              className="w-full py-3 bg-[#1ABC9C] text-white font-semibold rounded-xl hover:bg-[#16a085] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-eye-line ml-2"></i>
              الدخول كزائر
            </button>

            <button
              onClick={handleTeacherLogin}
              className="w-full py-3 bg-gradient-to-r from-[#0F2A3A] to-[#1a3d52] text-white font-semibold rounded-xl hover:shadow-xl transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-user-star-line text-xl"></i>
              دخول عضو هيئة تدريس
            </button>
          </div>
        </div>

        <div className="text-center mt-6">
          <button
            onClick={() => navigate('/welcome')}
            className="text-slate-600 hover:text-slate-800 font-semibold whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-right-line ml-2"></i>
            العودة للصفحة الرئيسية
          </button>
        </div>
      </div>
    </div>
  );
}
